import {SendMessageRequestData, SendMessageResponse} from "./constants";
import axiosClient from "../../system/helpers/axiosConfig";

export const sendOrder = (data: SendMessageRequestData) => {
  return axiosClient
    .post<SendMessageResponse>(`/api/feedback/send`, data)
    .then((r) => r.data.data);
};